module.exports = flarum.core.compat['common/states/ComposerState'];